import { default as config} from '../constants';

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(config.STOREAGE_KEY, serializedState);
  } catch (err) {
    // Ignore write errors.
  }
};

export const clearState = () => {
	try {
		localStorage.clear()
	} catch (err) {
		// no error handling here!
	}
}

export const loadState = () => {
	if(config.ENABLE_CACHE === false) {
		return undefined;
	}
	
  try {
    const serializedState = localStorage.getItem(config.STOREAGE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};


// WEBPACK FOOTER //
// ./src/store/localStorage.js